import React from 'react';
import { connect } from 'dva';
import { injectIntl } from 'react-intl';
import CustomReport from '../components/report/CustomReport';

export default connect(state => ({ ...state, loading: state.loading.global }))(
  injectIntl(({ customReport, loading, intl, dispatch }) => {
    return (
      <div className="container-left">
        <CustomReport
          intl={intl}
          dispatch={dispatch}
          customReport={customReport}
          loading={loading}
        />
      </div>
    );
  })
);



// WEBPACK FOOTER //
// ./src/routes/CustomReport.js